export default __webpack_public_path__ + "static/media/Il_giorno_del_bagno.5bc9aeac.jpg";